import React from 'react';
import {TextStyle, View, ViewStyle} from 'react-native';
import {get} from 'lodash';

import Checkbox from '/component/base/Checkbox';
import InlineFormattedNumber from '/component/base/FormattedNumber/InlineFormattedNumber';
import ListItem from '/component/base/ListItem';
import ProgressBar from '/component/base/ProgressBar';
import Text from '/component/base/Text';
import {Rank} from '/constant/TestIDs';

import {styles} from './PercentageProgressListItem.style';
interface StyleProps {
  listItem?: ViewStyle;
  numericProgressText?: TextStyle;
}
interface PercentageProgressListItemProps {
  style: StyleProps;
  hasCheckbox: boolean;
  isChecked: boolean;
  label: React.ReactNode;
  numerator: number;
  denominator: number;
  readonly: boolean;
  oneLineLayout: boolean;
  testID: string;
}

export const PercentageProgressListItem: React.FC<
  PercentageProgressListItemProps
> = ({
  style = {},
  hasCheckbox = false,
  isChecked = false,
  label = null,
  numerator,
  denominator,
  readonly = false,
  oneLineLayout = false,
  testID,
}) => {
  const progress = (numerator / denominator) * 100;

  const progressContainerStyle = [styles.progressContainer];
  if (!oneLineLayout) {
    // @ts-expect-error TS(2345): Argument of type '{ marginTop: number; }' is not a... Remove this comment to see the full error message
    progressContainerStyle.push(styles.progressContainerMultiLine);
  }

  const progressBarContainerStyle = [styles.progressBarContainer];
  if (oneLineLayout) {
    progressBarContainerStyle.push(styles.progressBarContainerOneLine);
  } else {
    progressBarContainerStyle.push(styles.progressBarContainerMultiLine);
  }

  const numericProgressStyle = {
    ...get(style, 'numericProgressText', {}),
  };

  const renderedProgress = (
    <View style={progressContainerStyle}>
      <View style={progressBarContainerStyle}>
        <ProgressBar testID={Rank.listItemProgress} progress={progress} />
      </View>
      <InlineFormattedNumber
        testID={Rank.listItemFractionBefore}
        textEmphasis="low"
        value={numerator}
      />
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        style={numericProgressStyle}
        variant="button"
        emphasis="low">
        {' / '}
      </Text>
      <InlineFormattedNumber
        testID={Rank.listItemFractionAfter}
        textEmphasis="low"
        value={denominator}
      />
    </View>
  );

  const listItemLabel = (
    <>
      <Text allowFontScaling maxFontSizeMultiplier={2}>
        {label}
      </Text>
      {!oneLineLayout && renderedProgress}
    </>
  );

  const listItemSuffix = oneLineLayout ? renderedProgress : null;

  const listItemStyle = {
    ...get(style, 'listItem', {}),
    suffix: styles.suffix,
  };

  return (
    <ListItem
      style={listItemStyle}
      readonly={readonly}
      prefix={
        hasCheckbox && (
          <Checkbox testID="checkbox" checked={isChecked} readonly={readonly} />
        )
      }
      label={listItemLabel}
      suffix={listItemSuffix}
      testID={testID}
    />
  );
};

export default PercentageProgressListItem;
